/** 15 §3.3 asset map: the three latin woff2 files as Vite asset URLs. Only main.ts imports this (fonts.ts stays node-pure). */
import barlow500 from './BarlowCondensed-500.woff2?url'
import barlow700 from './BarlowCondensed-700.woff2?url'
import plex400 from './IBMPlexMono-400.woff2?url'
import type { FontFile } from '../../fonts.js'

export const FONT_FILES: FontFile[] = [
  { family: 'Barlow Condensed', weight: '500', url: barlow500 },
  { family: 'Barlow Condensed', weight: '700', url: barlow700 },
  { family: 'IBM Plex Mono', weight: '400', url: plex400 },
]
